<template>
  <div
    class="relative w-full min-h-[320px] lg:min-h-[460px] p-6 lg:px-10 lg:pt-10 rounded-3xl overflow-hidden"
  >
    <div class="relative">
      <div class="space-y-2 mb-6">
        <h3 class="text-xl text-dark font-semibold">{{ id }}. {{ title }}</h3>
        <p class="text-sm text-gray">{{ description }}</p>
      </div>
      <RouterLink to="/auth/register">
        <Button
          variant="primary"
          size="md"
          v-if="action"
          icon="icon-link text-white text-base !font-bold"
          icon-position="left"
          :text="$t('landing.start_steps.steps.sign_up_to_connect')"
        />
      </RouterLink>
    </div>
    <div
      class="absolute -right-10 lg:-right-20 w-[380px] lg:w-[420px]"
      :class="[
        { '!top-42 lg:top-60 -right-6 lg:-right-12': id === 1 },
        id === 3 ? 'top-42 lg:top-56' : 'top-42 lg:top-44',
      ]"
    >
      <img
        :src="image"
        alt="Step info"
        class="w-full h-full object-contain"
        loading="lazy"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import Button from "@/modules/Landing/components/Base/Button/Button.vue";

interface Props {
  id: number;
  title: string;
  description: string;
  action: boolean;
  image: string;
}
defineProps<Props>();
</script>

<style scoped></style>
